import type { TypographyOptions } from "@mui/material/styles/createTypography";

// Current values from index.tsx, minus the unused `fontWeightLight`. The real type scale lands
// in a later phase; see docs/engineering/design/frontend_design_system_design.md section 4.1.
// `fontSize: 12` makes MUI scale every default variant by 12/14, which is why nothing renders
// at 14px today.
export const typography: TypographyOptions = {
  fontFamily: '"Quicksand", "Helvetica", "Arial", sans-serif',
  fontSize: 12,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
};
